import * as React from 'react';

const useLatest = current => {
  const storedValue = React.useRef(current);
  storedValue.current = current;
  return storedValue;
};

export default useLatest;